export default __webpack_public_path__ + "static/media/armaghan-logo-sm.c372990a.png";